import { Button } from "primereact/button";

import { formatarNumeroRolada } from "../shared";

export default function PlanejamentoRoladas({
    exibirInativas,
    onAdicionarLinha,
    onBlurLinha,
    onChangeExibirInativas,
    onTecla,
    onAtualizarCampo,
    planilhaRef,
    quantidadeInativas,
    roladas,
}) {
    return (
        <>
            <div className="p-d-flex p-flex-wrap p-jc-between p-ai-center p-mb-2" style={{ gap: 12 }}>
                <Button
                    className="p-button-sm"
                    icon="pi pi-plus"
                    label="Adicionar linha"
                    onClick={() => onAdicionarLinha()}
                />
                <div className="p-d-flex p-flex-wrap p-ai-center" style={{ gap: 16 }}>
                    <label className="p-d-flex p-ai-center" style={{ cursor: 'pointer', gap: 6 }}>
                        <input
                            checked={exibirInativas}
                            onChange={(event) => onChangeExibirInativas(event.target.checked)}
                            type="checkbox"
                        />
                        Exibir inativas ({quantidadeInativas})
                    </label>
                    <small>
                        Use Tab para avançar entre os campos.
                    </small>
                </div>
            </div>

            <div style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', marginBottom: 12, padding: 12 }}>
                <div style={{ marginBottom: 8 }}>
                    <strong>Planejamento:</strong> cada linha representa uma rolada futura. Ao ser registrada no SPI,
                    ela deixa de ser considerada aqui.
                </div>
                <div style={{ marginBottom: 8 }}>
                    <strong>Datas:</strong> início da produção e previsão de quando os rolos estarão disponíveis para
                    a tecelagem.
                </div>
                <div>
                    <strong>Salvamento:</strong> ao sair da linha, aguarde a situação mudar para “Salva no sistema”.
                </div>
            </div>

            <div ref={planilhaRef} style={{ overflowX: 'auto' }}>
                <table style={{ borderCollapse: 'collapse', minWidth: 1180, width: '100%' }}>
                    <thead>
                        <tr>
                            {['#', 'Rolada', 'Artigo', 'Metragem total', 'Início planejado', 'Disponibilidade planejada', 'Ativa na previsão', 'Situação'].map((titulo) => (
                                <th key={titulo} style={{
                                    backgroundColor: '#f1f2f6',
                                    border: '1px solid #ced6e0',
                                    padding: 8,
                                    textAlign: 'left',
                                }}>
                                    {titulo}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {roladas.map((linha, linhaIndex) => (
                            <tr
                                key={linha.chave}
                                onBlur={(event) => onBlurLinha(event, linha, linhaIndex)}
                                style={{
                                    backgroundColor: linha.erro
                                        ? '#fff1f0'
                                        : (linha.salvando
                                            ? '#e3f2fd'
                                            : (linha.salvaRecentemente
                                                ? '#e8f5e9'
                                                : (linha.alterada ? '#fffbe6' : '#fff'))),
                                }}
                            >
                                <td style={{ border: '1px solid #ced6e0', padding: '0 8px', textAlign: 'center' }}>
                                    {linhaIndex + 1}
                                </td>
                                <td style={{ border: '1px solid #ced6e0', padding: 0 }}>
                                    <input
                                        data-chave={linha.chave}
                                        data-coluna="0"
                                        data-linha={linhaIndex}
                                        inputMode="numeric"
                                        maxLength={6}
                                        onChange={(event) => onAtualizarCampo(
                                            linha.chave,
                                            'numero_rolada',
                                            formatarNumeroRolada(event.target.value)
                                        )}
                                        onKeyDown={(event) => onTecla(event, linha, linhaIndex, 0)}
                                        placeholder="99-999"
                                        style={{ border: 0, boxSizing: 'border-box', padding: 8, width: '100%' }}
                                        value={linha.numero_rolada}
                                    />
                                </td>
                                <td style={{ border: '1px solid #ced6e0', padding: 0 }}>
                                    <input
                                        data-coluna="1"
                                        data-linha={linhaIndex}
                                        min="1"
                                        onChange={(event) => onAtualizarCampo(linha.chave, 'cod_artigo', event.target.value)}
                                        onKeyDown={(event) => onTecla(event, linha, linhaIndex, 1)}
                                        style={{ border: 0, boxSizing: 'border-box', padding: 8, width: '100%' }}
                                        type="number"
                                        value={linha.cod_artigo}
                                    />
                                </td>
                                <td style={{ border: '1px solid #ced6e0', padding: 0 }}>
                                    <input
                                        data-coluna="2"
                                        data-linha={linhaIndex}
                                        min="0.01"
                                        onChange={(event) => onAtualizarCampo(linha.chave, 'metragem_total', event.target.value)}
                                        onKeyDown={(event) => onTecla(event, linha, linhaIndex, 2)}
                                        step="0.01"
                                        style={{ border: 0, boxSizing: 'border-box', padding: 8, width: '100%' }}
                                        type="number"
                                        value={linha.metragem_total}
                                    />
                                </td>
                                <td style={{ border: '1px solid #ced6e0', padding: 0 }}>
                                    <input
                                        data-coluna="3"
                                        data-linha={linhaIndex}
                                        onChange={(event) => onAtualizarCampo(linha.chave, 'data_inicio_planejada', event.target.value)}
                                        onKeyDown={(event) => onTecla(event, linha, linhaIndex, 3)}
                                        style={{ border: 0, boxSizing: 'border-box', padding: 8, width: '100%' }}
                                        type="date"
                                        value={linha.data_inicio_planejada}
                                    />
                                </td>
                                <td style={{ border: '1px solid #ced6e0', padding: 0 }}>
                                    <input
                                        data-coluna="4"
                                        data-linha={linhaIndex}
                                        onChange={(event) => onAtualizarCampo(linha.chave, 'data_disponibilidade_planejada', event.target.value)}
                                        onKeyDown={(event) => onTecla(event, linha, linhaIndex, 4)}
                                        style={{ border: 0, boxSizing: 'border-box', padding: 8, width: '100%' }}
                                        type="date"
                                        value={linha.data_disponibilidade_planejada}
                                    />
                                </td>
                                <td style={{ border: '1px solid #ced6e0', padding: 0, textAlign: 'center' }}>
                                    <input
                                        checked={linha.ativo}
                                        data-coluna="5"
                                        data-linha={linhaIndex}
                                        onChange={(event) => onAtualizarCampo(linha.chave, 'ativo', event.target.checked)}
                                        onKeyDown={(event) => onTecla(event, linha, linhaIndex, 5)}
                                        type="checkbox"
                                    />
                                </td>
                                <td style={{ border: '1px solid #ced6e0', maxWidth: 260, padding: 8 }}>
                                    <span style={{
                                        color: linha.erro
                                            ? '#c62828'
                                            : (linha.salvando
                                                ? '#1565c0'
                                                : (linha.salvaRecentemente ? '#2e7d32' : '#455a64')),
                                        fontWeight: linha.salvando || linha.salvaRecentemente ? 700 : 400,
                                    }}>
                                        {linha.salvando
                                            ? 'Enviando...'
                                            : (linha.erro || (linha.salvaRecentemente
                                                ? 'Salva no sistema'
                                                : (linha.alterada ? 'Alterada' : (linha.id ? 'Salva' : 'Nova'))))}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}
